module.exports = __webpack_public_path__ + "img/brain_face.cf3581aa.svg";